import { render, staticRenderFns } from "./BaseColorInput.vue?vue&type=template&id=bf458d5e&scoped=true&"
import script from "./BaseColorInput.vue?vue&type=script&lang=js&"
export * from "./BaseColorInput.vue?vue&type=script&lang=js&"
import style0 from "./BaseColorInput.vue?vue&type=style&index=0&id=bf458d5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf458d5e",
  null
  
)

export default component.exports